import Button from "./Button";
import isMobile from "ismobilejs";

/**
 * @class
 * @extends P3.Button
 */
export default class MuteButton extends Button {
    /**
     * @param {ButtonStates} states
     */
    constructor(states) {
        super(states);

        this._currentIconTexture = this.isEnabled() ? this._states.icon : this._states.iconAlt;
        this._currentIconOverTexture = this.isEnabled() ? this._states.iconOver : this._states.iconOverAlt;
        this._currentIconDownTexture = this.isEnabled() ? this._states.iconDown : this._states.iconDownAlt;

        this._icon.texture = (this._states.iconOver && !isMobile.any) ? this._currentIconOverTexture : this._currentIconTexture;
    }

    /**
     * @param {Event} event
     * @private
     */
    _onMouseClick(event) {
        this._currentIconTexture = !this.isEnabled() ? this._states.icon : this._states.iconAlt;
        this._currentIconOverTexture = !this.isEnabled() ? this._states.iconOver : this._states.iconOverAlt;
        this._currentIconDownTexture = !this.isEnabled() ? this._states.iconDown : this._states.iconDownAlt;

        this._icon.texture = (this._states.iconOver && !isMobile.any) ? this._currentIconOverTexture : this._currentIconTexture;

        if(!!Button.audio){
            Button.audio.mute(!Button.audio.isMute);
        }
        super._onMouseClick(event);
    }

    /**
     * @returns {boolean}
     */
    isEnabled() {
        return !!Button.audio && !Button.audio.isMute;
    }
}